import { createTheme } from '@mui/material'
import { defaultColors } from '../../../../infrastructure/materialUiThemeProvider'

export let customDatePickerTheme = createTheme({
    palette: {},
    components: {
        //@ts-ignore
        MuiPickersToolbar: {
            styleOverrides: {
                root: {
                    backgroundColor: defaultColors.darkBlue.main.color,
                    color: 'white',
                    '& .MuiTypography-root': {
                        color: 'white',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: 'black',
                        border: 'none',
                        boxShadow: 'none',
                        '& svgIcon-root': {
                            display: 'none'
                        },
                    },
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                    '&.Mui-disabled': {
                        backgroundColor: 'white',
                        color: 'black',
                        border: 'none',
                        boxShadow: 'none',
                        '& .MuiSvgIcon-root': {
                            display: 'none',
                        },
                    },
                    '&.Mui-disabled:before, &.Mui-disabled:after': {
                        borderBottom: 'none !important',
                    },
                },
                input: {
                    color: 'black',
                    '&.Mui-disabled': {
                        color: 'black',
                        WebkitTextFillColor: 'black',
                    }
                }
            }
        }
    }
})